import DraftPage from "../order-sim/DraftPage"
import { oiaEngine } from "./engine"

/** /oia-sim/:threadId/draft: the shared draft page with the OIA's paper. */
export default function OiaDraftPage() {
  return <DraftPage engine={oiaEngine} />
}
